import React from "react";

import classes from "../CSS/logo.module.css";

const logo = () => (
	<div className={classes.logo_div}>
		<div>S</div>
		<h2>Shirtsy</h2>
	</div>
);

export default logo;
